import type { IChartPlugin, IChartRegistry } from '@chartforge/shared-types';

/**
 * Central registry of chart plugins. Platforms and the demo resolve charts
 * by id through this registry — never by importing plugin implementations
 * directly into host-specific code paths.
 */
export class ChartRegistry implements IChartRegistry {
  private readonly plugins = new Map<string, IChartPlugin>();

  register(plugin: IChartPlugin): void {
    if (!plugin || typeof plugin.id !== 'string' || plugin.id.length === 0) {
      throw new Error('Chart plugin must have a non-empty string id');
    }
    if (this.plugins.has(plugin.id)) {
      throw new Error(`Chart plugin already registered: "${plugin.id}"`);
    }
    this.plugins.set(plugin.id, plugin);
  }

  get(id: string): IChartPlugin | undefined {
    return this.plugins.get(id);
  }

  list(): IChartPlugin[] {
    return [...this.plugins.values()];
  }
}

export function createRegistry(plugins: IChartPlugin[] = []): ChartRegistry {
  const registry = new ChartRegistry();
  for (const plugin of plugins) {
    registry.register(plugin);
  }
  return registry;
}
